import { useEventContent } from "@/context/EventContentContext";

export default function Chefs() {
  const { chefs } = useEventContent();

  return (
    <div data-testid="chefs-page" className="section-pad">
      <div className="container-cg">
        <div className="overline text-[var(--brand-primary)]">Chefs e invitados especiales</div>
        <h1 className="font-serif-cg text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3">
          Las manos detrás de la mesa.
        </h1>
        <p className="max-w-2xl mt-5 text-[var(--brand-muted)] leading-relaxed">
          Chefs, artistas, productores y aliados educativos que dan forma a la Edición León 450.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7 mt-14">
          {chefs.map((c, idx) => (
            <article
              key={c.name}
              data-testid={`chef-card-${idx}`}
              className="card-cg overflow-hidden img-zoom-host group"
            >
              <div className="aspect-[4/5] overflow-hidden bg-[var(--brand-surface-alt)]">
                <img src={c.photo} alt={c.name} className="img-zoom w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="overline text-[var(--brand-primary)]">{c.role}</div>
                <h3 className="font-serif-cg text-2xl mt-2 tracking-tight">{c.name}</h3>
                <p className="mt-3 text-sm text-[var(--brand-ink)]/80 leading-relaxed">{c.bio}</p>
                <div className="hairline my-4" />
                <p className="text-xs text-[var(--brand-muted)]">
                  <span className="overline mr-2">Participación</span>
                  {c.participation}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
